import { render, staticRenderFns } from "./MUpload.vue?vue&type=template&id=5e492036&scoped=true&"
import script from "./MUpload.vue?vue&type=script&lang=js&"
export * from "./MUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e492036",
  null
  
)

export default component.exports